var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMessage),expression:"showMessage"}],staticClass:"col-12 pb-4"},[_c('div',{staticClass:"required-field-bottom"},[_c('small',{staticClass:"pl-2",staticStyle:{"color":"#909090"}},[_vm._v("\n        "+_vm._s(_vm.MessageDisplay)+"\n      ")])])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02a1b102","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/TableEditMessage.vue
// module id = null
// module chunks = 